module.exports = "<md-button id=report-settings ng-click=$ctrl.openBottomSheet()> <md-icon>more_vert</md-icon> <md-tooltip>Acciones</md-tooltip> </md-button> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/tsz-report-menu-actions/tsz-report-menu-actions.html
// module id = 143
// module chunks = 1